import { LOCATION_TYPE } from '../constants'
import { getLocationType } from './getLocationType'

export const isLocationCity = (location) =>
  getLocationType(location) === LOCATION_TYPE.CITY
